import { useRouter } from 'next/router';

import { flattenGetParam } from '@lib/utils/strings';

/**
 * Extract a get param from a router and automatically flatten it. ex:
 * ```ts
 *    const storeId = useNextRouterParam('storeId');
 * ```
 *
 * `/path/[storeId].tsx -> /path/171 -> 171`
 *
 * NB: this will not treat array values correctly, e.g. /path?param=1&param=2
 */
const useNextRouterParam = (param: string): string | undefined => {
    const router = useRouter();
    const paramValue = router.query[param];

    if (paramValue) {
        return flattenGetParam(paramValue);
    }
};

export default useNextRouterParam;
